function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.967,112.274H21.821a1.455,1.455,0,1,0,0-2.909H4.967l1.881-1.881a1.455,1.455,0,1,0-2.057-2.057L.426,109.79c-.034.034-.066.069-.1.106l-.021.028c-.022.028-.044.057-.064.086l-.016.027c-.02.031-.04.063-.057.1l-.01.02c-.018.036-.036.072-.051.109l-.005.014c-.016.039-.03.079-.043.12,0,.005,0,.01,0,.016-.012.04-.022.081-.031.122,0,.012,0,.025-.006.037-.006.034-.012.069-.015.1a1.434,1.434,0,0,0,0,.29c0,.035.01.07.016.1,0,.012,0,.024.006.036.008.042.019.083.031.123l0,.015c.013.041.027.081.043.121l0,.013c.016.038.033.074.052.11l.009.019c.018.033.038.065.058.1l.016.026c.02.03.042.058.064.087l.021.028c.03.037.062.072.1.106l4.364,4.364a1.455,1.455,0,0,0,2.057-2.057Z",
  transform: "translate(0 -98.92)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M112.975,42.3a11.891,11.891,0,0,0-9.883,5.269,1.455,1.455,0,0,0,2.415,1.623,8.99,8.99,0,1,1,.012,10.033,1.455,1.455,0,0,0-2.411,1.629A11.9,11.9,0,1,0,112.975,42.3Z",
  transform: "translate(-92.871 -42.299)"
});

var SvgExitIcon = function SvgExitIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.004,
    height: 23.799,
    viewBox: "0 0 32.004 23.799",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExitIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exitIcon.63a339cc.svg";
export { ForwardRef as ReactComponent };